import { Injectable, signal } from '@angular/core';

/**
 * BrowserSharedService
 *
 * Lets a deeply nested feature component (e.g. voice-to-voice) ask the root
 * shell to change chrome it doesn't own — the global header/footer live in
 * AppComponent, outside the routed component tree, so there's no direct
 * parent/child relationship to bind an *ngIf/class through. A shared
 * root-provided signal is the simplest bridge.
 */
@Injectable({ providedIn: 'root' })
export class BrowserSharedService {
  readonly hideFooter = signal(false);
  /** HeaderComponent swaps its D&G logo for the "Smart-fix Voice" mark while this is true (mobile only). */
  readonly showVoiceBranding = signal(false);
}
